import { render, staticRenderFns } from "./archivesNeed.vue?vue&type=template&id=6c1c41af&scoped=true&"
import script from "./archivesNeed.vue?vue&type=script&lang=js&"
export * from "./archivesNeed.vue?vue&type=script&lang=js&"
import style0 from "./archivesNeed.vue?vue&type=style&index=0&id=6c1c41af&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c1c41af",
  null
  
)

export default component.exports